import { BaseError } from "platform-common/index"

interface PaymentRequiredErrorArgs {
  message?: string | null
  feature: string
  limit?: number | null
  used?: number | null
}

/**
 * Error thrown when a user has exceeded their quota for a feature
 * or the feature is not available for their account type.
 */
export class PaymentRequiredError extends BaseError {
  limit?: number | null
  used?: number | null

  constructor({ message, feature, limit, used }: PaymentRequiredErrorArgs) {
    super(message || `Payment required for feature: ${feature}`)

    console.error(`Payment required to access "${feature}".`, { limit, used })

    this.limit = limit
    this.used = used
  }
}
